import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { AnalyticsTimeslice } from '@legacy/analytics/interfaces/analytics-timeslice';
import { Product } from '@legacy/analytics/interfaces/product';
import { Station } from '@legacy/analytics/interfaces/station';
import { ShipmentBasis } from '@legacy/analytics/interfaces/basis';

export const loadAnalyticsData = createAction('[Analytics] Load Data');

export const loadAnalyticsDataSuccess = createAction(
  '[Analytics] Data Loaded Succeffully',
  props<{ data: AnalyticsTimeslice[] }>(),
);

export const loadAnalyticsDataFailure = createAction(
  '[Analytics] Data Loading Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const updateAnalyticsData = createAction('[Analytics] Update Data');

export const updateAnalyticsDataSuccess = createAction(
  '[Analytics] Data Updated Succeffully',
  props<{ data: AnalyticsTimeslice[] }>(),
);

export const updateAnalyticsDataFailure = createAction(
  '[Analytics] Data Update Failure',
  props<{ error: string }>(),
);

export const setAnalyticsProductGroup = createAction(
  '[Analytics] Set Product Group',
  props<{ productGroup: Product }>(),
);

export const setAnalyticsDestination = createAction(
  '[Analytics] Set Destination',
  props<{ destination: Station }>(),
);

export const setAnalyticsShipments = createAction(
  '[Analytics] Set Shipments',
  props<{ shipments: ShipmentBasis[] }>(),
);

export const setAnalyticsScale = createAction(
  '[Analytics] Set Scale',
  props<{ scale: string }>(),
);
